import { render, staticRenderFns } from "./HotelMainText.vue?vue&type=template&id=693b9bae&scoped=true&"
import script from "./HotelMainText.vue?vue&type=script&lang=js&"
export * from "./HotelMainText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693b9bae",
  null
  
)

export default component.exports